import React from "react";
import { API, graphqlOperation } from "aws-amplify";
import MaterialTable from "material-table";
import * as Router from "@reach/router";
import common from "features/common/commonSlice";
import { useDispatch } from "react-redux";
import * as queries from "graphql/queries";
import * as subscriptions from "graphql/subscriptions";
import * as listSettings from "settings/ListSettings";
import { pascalCase } from "change-case";
// import { useTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";
import pluralize from "pluralize";
export interface ShowProps extends Router.RouteComponentProps {}

type Props = {
  type: string;
  dialog?: boolean;
  variables?: {};
  childList?: "";
  belong?: { key: string; target: string };
  createLimit?: Number;
  hidePreview?: boolean;
  enableDelete?: (rowData: any) => boolean;
};

const defalutProps = {
  dialog: false,
  variables: {},
};

function Table(props: Props) {
  const {
    type,
    childList,
    belong,
    variables,
    dialog,
    createLimit,
    hidePreview,
    enableDelete,
  } = props;
  const dispatch = useDispatch();
  const location = Router.useLocation();
  const { t } = useTranslation();
  const [list, setList] = React.useState([]);
  const [columns, setColumns] = React.useState<any>([]);

  const listQuery = `list${pascalCase(type)}`;
  // const subQuery = `onCreate${pluralize.singular(pascalCase(type))}`;

  React.useEffect(() => {
    async function f() {
      dispatch(common.actions.fetchStart());
      try {
        const res = await API.graphql(
          // @ts-ignore
          graphqlOperation(queries[listQuery], variables)
        );
        // @ts-ignore
        const { items } = res.data[listQuery];
        setList(items);
        //@ts-ignore
        const colmuns = listSettings[type];
        if (colmuns) {
          const myColums = colmuns.map((item: any) => {
            if ("img" in item && item.img) {
              return {
                title: t(item.key),
                field: item.key,
                render: (rowData) => (
                  <img src={rowData[item.key]} style={{ width: "4em" }} />
                ),
              };
            }
            if ("defaultSort" in item && item.defaultSort) {
              return {
                title: t(item.key),
                field: item.key,
                defaultSort: item.defaultSort,
              };
            }
            return {
              title: t(item.key),
              field: item.key,
            };
          });
          setColumns(myColums);
        } else {
          if (columns.length === 0) {
            if (items.length > 0) {
              const myColums = Object.keys(items[0]).map((key, index) => {
                return {
                  title: t(key),
                  field: key,
                };
              });
              setColumns(myColums);
            } else {
              setColumns([{ name: "id", field: "id" }]);
            }
          }
        }

        dispatch(common.actions.fetchSuccess());
      } catch (error) {
        console.error("listQuery", error);
        dispatch(common.actions.fetchFailure(error));
      }
    }

    const sub = () => {
      // @ts-ignore
      ["Create", "Update", "Delete"].forEach((method) => {
        const subQuery = `on${method}${pluralize.singular(pascalCase(type))}`;
        // @ts-ignore
        API.graphql(graphqlOperation(subscriptions[subQuery])).subscribe({
          next: (res: any) => {
            async function f() {
              const res = await API.graphql(
                // @ts-ignore
                graphqlOperation(queries[listQuery], variables)
              );
              // @ts-ignore
              const { items } = res.data[listQuery];
              setList(items);
            }
            f();
          },
        });
      });
    };

    f();
    // console.log("subscriptions:", subscriptions);
    sub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const actions = [
    (rowData) => ({
      icon: "delete",
      tooltip: "削除",
      onClick: async (event) => {
        if (enableDelete) {
          const enable = await enableDelete(rowData);
          if (!enable) {
            event.preventDefault();
            return;
          }
        }
        Router.navigate(`${location.pathname}/${rowData.id}/delete`, {
          state: {
            background: location,
          },
        });
      },
    }),
  ];

  if (hidePreview !== true) {
    actions.push((rowData) => ({
      icon: "preview",
      tooltip: "preview",
      onClick: (event) =>
        Router.navigate(`${location.pathname}/${rowData.id}/preview`, {
          state: {
            background: location,
          },
        }),
    }));
  }

  if (!createLimit || list.length < createLimit) {
    actions.push({
      icon: "add",
      tooltip: "新規",
      isFreeAction: true,
      onClick: () =>
        Router.navigate(`${location.pathname}/_/new`, {
          state: {
            background: dialog ? location : undefined,
          },
        }),
    });
  }
  if (childList) {
    actions.push((rowData) => ({
      icon: "list",
      tooltip: "一覧",
      onClick: (event) =>
        Router.navigate(`${location.pathname}/${rowData.id}/${childList}`),
    }));
  }

  if (belong) {
    actions.push((rowData) => ({
      icon: "info",
      tooltip: "補足",
      onClick: async (event) => {
        const _query = `list${pascalCase(belong.target)}`;
        let filter = {};
        // @ts-ignore
        filter[belong.key] = { eq: rowData.id };
        // @ts-ignore
        const res_belongs = await API.graphql(
          graphqlOperation(queries[_query], {
            filter: filter,
          })
        );
        console.log(res_belongs);
        if (res_belongs.data[_query].items.length > 0) {
          Router.navigate(
            `${location.pathname}/${rowData.id}/${belong.target}/${res_belongs.data[_query].items[0].id}/edit`,
            {
              state: {
                background: location,
              },
            }
          );
        } else {
          Router.navigate(
            `${location.pathname}/${rowData.id}/${belong.target}/_/new`,
            {
              state: {
                background: location,
              },
            }
          );
        }
      },
    }));
  }

  return (
    <>
      {columns.length > 0 && (
        <MaterialTable
          title={t(type)}
          columns={columns}
          data={list}
          onRowClick={(event, rowData: any) => {
            if (rowData && rowData.id) {
              Router.navigate(`${location.pathname}/${rowData.id}/edit`, {
                state: {
                  background: dialog ? location : undefined,
                },
              });
            }
          }}
          actions={actions}
        />
      )}
    </>
  );
}

Table.defaultProps = defalutProps;
export default Table;
